/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Show_CpsInputs */



/**
* | output |
* | --- |
* | "Show Characters Per Second (CPS)" |
*
* @param {Options_Metrics_Show_CpsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_show_cps = /** @type {((inputs?: Options_Metrics_Show_CpsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Show_CpsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Show Characters Per Second (CPS)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Show Characters Per Second (CPS)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Show Characters Per Second (CPS)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Show Characters Per Second (CPS)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Show Characters Per Second (CPS)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Show Characters Per Second (CPS)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Show Characters Per Second (CPS)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Show Characters Per Second (CPS)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Show Characters Per Second (CPS)")
	return /** @type {LocalizedString} */ ("Show Characters Per Second (CPS)")
});